<ng-template #tplItem let-item="item">
  @let badgeSize = item.badgeCount?.toString()?.length >= 2 ? 'large' : 'medium';
  <div class="wrapper-icon" [class.has-icon]="item.icon">
    @if (item.icon) {
      <ui-icon
        [faName]="item.icon.name"
        [matBadgeSize]="badgeSize"
        [faStyle]="item.icon.family"
        [matBadge]="item.badgeCount"
        matBadgePosition="above after"
      ></ui-icon>
    }
  </div>
  <span>{{ item.label }}</span>
</ng-template>

@for (item of items(); track item) {
  <div class="wrapper-link">
    <div
      [class.link-active]="isItemActive(item)"
      class="wrapper-link-content"
      mat-ripple
      role="button"
    >
      <ng-container *ngTemplateOutlet="tplItem; context: { item }"></ng-container>

      @if (item.url) {
        <a uiNavLink [link]="item"></a>
      }
    </div>
  </div>
}
